import styled from 'styled-components';
import { Card as ShrikeCard } from '@perch-labs/shrike';

export const Card = styled(ShrikeCard)<StyleProps>`
  .apexcharts-xaxis-label {
    font-family: ${props => props.theme.fontFamilies.main.regular};

    ${props => `
      &:nth-child(${props.xAxisLabelChildIndex}) {
        fill: ${props.theme.colors.content.secondary};
        font-weight: bold;
        font-size: ${props => props.theme.fontSizes[400]};
      }
    `}
  }

  /* style header title */
  h2 span {
    opacity: ${props => props.theme.opacities.medium};
    font-family: ${props => props.theme.fontFamilies.main.regular};
  }
`;
